module.exports = __webpack_public_path__ + "static/media/980246.d7e1293d.jpg";